// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DialogChat__Component__Loading {\n  display: flex;\n  gap: 15px;\n  max-height: 684px;\n}\n.input_select {\n  padding: 0 0 4px 0;\n  background: none;\n  border: 1px solid rgba(60, 60, 60, 0.26);\n  border-radius: 4px;\n  white-space: normal;\n}\n.DialogChat__Container {\n  max-height: 275px;\n  min-height: 200px;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
